import React, { useState } from 'react';
import { useLogin } from '../../hooks/api/auth/auth';
import { useNavigate } from 'react-router';
import { toast } from 'react-toastify';

const AdminLogin = () => {

  const loginAPI= useLogin()
  const navigate= useNavigate()
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(''); // Clear any previous errors
    toast.dismiss()
toast.loading(`Please Wait... Logging In`)
    try {
      // Simulate API call (replace with your actual API endpoint)
      loginAPI.mutateAsync({email:username, password:password}, {
        onSuccess(data){
          toast.dismiss()
          toast.success( `Login Successful`)
          sessionStorage.setItem('token', data.token)
          sessionStorage.setItem('orgId', data.orgId)
          sessionStorage.setItem('userId', data.userId)
navigate(`/admin`)
        },
        onError(error) {
          console.log({error})
          toast.dismiss()
          toast.error(`${error?.response?.data?.message}`)
        }
      })
     

    } catch (err) {
      setError('An error occurred. Please try again later.');
      console.error("Login error:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="bg-white p-8 rounded-lg shadow-md w-full max-w-md">
        <h2 className="text-2xl font-bold mb-4 text-center text-gray-800">Admin Login</h2>

        {error && <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4" role="alert">
          <strong className="font-bold">Error!</strong>
          <span> {error}</span>
        </div>}

        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label htmlFor="username" className="block text-gray-700 text-sm font-bold mb-2">Email</label>
            <input
              type="email"
              id="username"
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </div>
          <div className="mb-6">
            <label htmlFor="password" className="block text-gray-700 text-sm font-bold mb-2">Password</label>
            <input
              type="password"
              id="password"
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <div className="flex items-center justify-between">
            <button
              type="submit"
              className={`bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline ${loading ? 'opacity-75 cursor-not-allowed' : ''}`}
              disabled={loading} // Disable the button while loading
            >
              {loading ? <span className="animate-spin mr-2"> 🔄 </span> : null} {/* Loading spinner */}
              Sign In
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;